/*!@license
 *
 * Minisiti agenzie
 * TEAM ADA Bluvacanze
 * Massimo Cassandro / Gianluca Canale / Riccardo Cattaneo
 *
 */

import fontloader from './src/fontloader';
import cookieconsent from './src/cookieconsent';
import menuTrigger from './src/menu-trigger';

import 'lazysizes';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/carousel';

import doveSiamo from './src/dove-siamo';

(() => {

  fontloader();
  cookieconsent();
  menuTrigger();

  // flasmessages close
  $('.flash-message .close').click(function () {
    $(this).parents('.flash-message').remove();
  });

  // campi required
  $('input[required], select[required], textarea[required]').each(function() {
    var container = $(this).closest('.form-group'), //$(this).parents('.form-group').eq(0),
      _label;

    if(container.length) {
      if(container.find('.label').length) {
        _label = container.find('.label').eq(0);

      } else {
        _label = container.find('label').eq(0);
      }

      if(_label.length) {
        _label.addClass('required').html(_label.html().replace(/^\*\s?/, ''));
      }
    }
  });


  // fancybox default
  if($.fancybox !== undefined) {

    $.fancybox.defaults = $.extend($.fancybox.defaults, {
      lang : 'it',
      i18n : {
        'it' : {
          CLOSE       : 'Chiudi',
          NEXT        : 'Successivo',
          PREV        : 'Precedente',
          ERROR       : 'Il contenuto richiesto non può essere caricato.<br/>Prova nuovamente',
          PLAY_START  : 'Avvia proiezione',
          PLAY_STOP   : 'Metti la proiezione in pausa',
          FULL_SCREEN : 'Schermo intero',
          THUMBS      : 'Miniature',
          DOWNLOAD    : 'Download',
          SHARE       : 'Condividi',
          ZOOM        : 'Zoom'
        }
      },
      toolbar     : true,
      infobar     : true,
      smallBtn    : false,
      /*
      buttons     : [
        'close'
      ],
      */
      iframe      : {
        css: {
          'max-width'  : '960px',
          'max-height' : '80%'
        }
      }
    });
  } // end if($.fancybox !== undefined)


  const pid = document.body.dataset.pid.toLowerCase();
  if(pid === 'dove_siamo') {
    doveSiamo();
  }

})();
